import TextArea from 'antd/es/input/TextArea';
import React from 'react';

import mapModifiers from 'utils/functions';

interface TextAreaProps extends React.ComponentProps<typeof TextArea> {
  errText?: string;
  view?: boolean;
  iconButton?: React.ReactNode;
}

const TextAreaCustom: React.FC<TextAreaProps> = ({
  errText, view, iconButton, ...props
}) => (
  <div className={mapModifiers('a-textArea', view ? 'view' : '', errText && 'error', !!iconButton && 'withButton')}>
    <TextArea
      {...props}
      disabled={view}
    />
    {iconButton && (
      <div className="a-textarea_iconBtn">
        {iconButton}
      </div>
    )}
    {errText && <div className="a-textArea_errText">{errText}</div>}
  </div>
);

export default TextAreaCustom;
